export function middleDots(str, sideLength) {
    if (sideLength === void 0) { sideLength = 4; }
    if (!str) {
        return '';
    }
    var DOTS_LENGTH = 3;
    var SIDE_LENGTH = sideLength || 12;
    if (str.length <= SIDE_LENGTH + SIDE_LENGTH + DOTS_LENGTH) {
        return str;
    }
    return "".concat(str.slice(0, SIDE_LENGTH), " \u2022\u2022\u2022\u2022 ").concat(str.slice(-SIDE_LENGTH));
}
export function actionLabel(type, needAddZeroId) {
    if (needAddZeroId) {
        return 'Add ZeroID to Metamask';
    }
    if (type === 'multi') {
        return 'Create new order';
    }
}
